/* eslint-disable no-unused-vars */
import { getApiCall, putApiCall, postApiCall,  } from "../utils/request";
import { returnErrors } from "./errorAction";
import { GET_PROFILE, UPDATE_PROFILE, ADD_EDUCATION, GET_COLLEGES, GET_COURSES, CLOSE_SEARCH, CHANGE_PASSWORD } from '../actionType/type';

export const getProfileDetails = () => async (dispatch) => {
    try {
        const response = await getApiCall(`user/profile`);
        dispatch({
            type: GET_PROFILE, payload: response.data.data
        })
    } catch (error) {
        returnErrors(dispatch, error.response !== undefined && error.response.data.message, error.response !== undefined && error.response.status);
    }
}

export const updateProfile = (obj) => async (dispatch) => {

    try {
        const response = await postApiCall('user/profile', obj);
        dispatch({ type: UPDATE_PROFILE, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response.data.message, error.response.status);
    }
}

export const addEducation = (obj) => async (dispatch) => {
    let education = {
        education: [obj]
    }
    try {
        const response = await postApiCall('user/profile/education', education);
        if (response.data.success) {
            dispatch({ type: ADD_EDUCATION });
            returnErrors(dispatch, "Education details has been successfully added", response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response.data.message, error.response.status);
    }
}

export const editEducation = (obj) => async (dispatch) => {

    try {
        const response = await postApiCall('user/profile/education/update', obj);
        if (response.data.success) {
            dispatch({ type: ADD_EDUCATION });
            returnErrors(dispatch, "Education details has been successfully updated", response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response.data.message, error.response.status);
    }
}

export const deleteEducation = (id) => async (dispatch) => {
    try {
        const response = await postApiCall(`user/profile/education/delete/${id}`);
        if (response.data.success) {
            // dispatch({ type: DELE_EDUCATION });
            returnErrors(dispatch, "Education details has been successfully deleted", response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response.data.message, error.response.status);
    }
}


export const getSearchCollege = (college) => async (dispatch) => {

    try {
        const response = await getApiCall(`helper/colleges/${college}`);
        const data = response.data.data
        dispatch({ type: GET_COLLEGES, payload: { data, college } });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const getSearchCourse = (course) => async (dispatch) => {

    try {
        const response = await getApiCall(`helper/degree/${course}`);
        const data = response.data.data
        dispatch({ type: GET_COURSES, payload: { data, course } });
    } catch (error) {
        returnErrors(dispatch, error?.response?.data.message, error?.response?.status);
    }
}

export const closeSearch = (college) => async (dispatch) => {
    return dispatch({ type: CLOSE_SEARCH, });

}

export const updateJobs = (obj) => async (dispatch) => {

    try {
        const response = await postApiCall('user/profile/jobs', obj);
        if (response.data.success) {
            // dispatch({ type: U});
            returnErrors(dispatch, "Job details has been successfully updated", response.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response.data.message, error.response.status);
    }
}

export const changePassword = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`user/profile/password-reset`, obj);
        if (response.data.success) {
            dispatch({ type: CHANGE_PASSWORD, payload: response.data });
            returnErrors(dispatch, 'Password has been changed successfully.Login again', response.status)
        }
        else {
            returnErrors(dispatch, response.data.message, response.status)
        }

    } catch (error) {
        returnErrors(dispatch, error.response.data.message, error.response.status);
    }
}